import React from 'react';
import { Link } from 'react-router-dom';
import brandsData from './brandsData';

const Brand = () => {
  return (
    <div className="container mx-auto py-8">
      <h1 className="text-3xl font-bold mb-8">Our Brands</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {brandsData.map((brand) => (
          <div key={brand.id} className="bg-white shadow-md rounded-lg p-6 m-4 border border-gray-300">
            <img src={brand.image} alt={brand.name} className="w-full h-40 object-cover mb-4" />
            <h2 className="text-xl font-bold mb-2">{brand.name}</h2>
            <p className="text-gray-700 mb-4">{brand.description}</p>
            <Link to={`/brands/${brand.id}`} className="text-blue-500 hover:underline">Learn more</Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Brand;
